import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { ThemesTableSelect } from './ThemesTableSelect';
import { ThemeField } from '../tsx/ThemeField';
import * as appTheme from '../ts/appTheme';
import { ParameterField } from './ParameterField';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';
import { IThemeState } from '../../../pdc-platform/src/ts/stores/ThemeStore';

const THEME_ID_LIST_FIELD_NAME = appTheme.THEME_ID_LIST_FIELD_NAME;

interface IThemesListFieldState extends IThemeState {
    value;
    multiSelectValue;
    custom: boolean;
    themeField: ThemeField;
    levels: any[];
    widgetValues?: any;
    widgetTypeName?: string;
    themeTypes: appTheme.IThemeTypesHash;
    infoTooltipVisible: boolean;
    invalid?: boolean;
    savedState?: any; //LL: 27.08.20
}

export default class ThemesListField extends React.Component<
    {
        value;
        levels?: any[];
        parentThemes?;

        options: {
            levels?: any[];
            parentTheme?;
            hideCustom?: boolean;

            widgetValues?: any;
            widgetTypeName?: string;

            savedState?: any; //LL: 27.08.20

            onThemeChange?(value, invalid: boolean): void;
        };
        glob: IGlob;

        onChange?(value, invalid: boolean): void;
    },
    IThemesListFieldState
> {
    constructor(props) {
        super(props);

        const levels = (this.props.options && this.props.options.levels) || this.props.levels;

        let widgetValues = this.props.options != null ? this.props.options.widgetValues : null;

        if (widgetValues != null) {
            widgetValues = $.extend(true, {}, widgetValues);
        }
        
        const widgetTypeName = this.props.options != null ? this.props.options.widgetTypeName : ''; //  ~~"pdc-widget-chart"

        let themeTypes: appTheme.IThemeTypesHash;

        if (levels == null) {
            themeTypes = this.props.glob.appTheme.state.themeTypesHash;
        } else {
            themeTypes = _.reduce(
                levels,
                (res, level: any) => {
                    const arr = this.props.glob.appTheme.state.themeTypesVisibility[level];

                    _.each(arr, (id) => {
                        res[id] = this.props.glob.appTheme.state.themeTypesHash[id];
                    });

                    return res;
                },
                {},
                this
            );
        }

        //LL: 27.08.20: used for ThemeField to save internal state (selected section and collapsed) through component rebuild
        let savedState =
            this.props.options != null && this.props.options.savedState != null ? this.props.options.savedState : {};

        this.state = _.extend(
            {},

            this.getState(),

            {
                themeField: new ThemeField(this.props.glob, 'Customize Options', [], {}),

                savedState: { savedState }, //LL: 27.08.20

                levels: levels || [],
                themeTypes: themeTypes,

                widgetValues: widgetValues,
                widgetTypeName: widgetTypeName,

                infoTooltipVisible: false
            },

            this.getValueState(this.props.value)
        );
    }

    getState() {
        return this.props.glob.ThemeStore.getState();
    }

    getValueState = (value) => {
        var keys = (value && value[THEME_ID_LIST_FIELD_NAME]) || [];
        var multiSelectValue = keys;

        return {
            multiSelectValue,
            value: value || {}
        };
    };

    componentDidMount() {
        this.props.glob.ThemeStore.addChangeListener(this._onChange);

        this.props.glob.AppActions.themeGetList();
    }

    componentWillUnmount() {
        this.props.glob.ThemeStore.removeChangeListener(this._onChange);
    }

    _onChange = () => {
        this.setState(this.getState());
    };

    componentWillReceiveProps(nextProps) {
        this.setState(this.getValueState(nextProps.value));
    }

    handleChange = (keys) => {
        var data: any = _.reduce(
            keys,
            (res, id: any) => {
                const data = this.state.themesData[id];

                if (data != null) {
                    res = appTheme.extend(res, data);
                }

                return res;
            },
            {}
        );

        data[THEME_ID_LIST_FIELD_NAME] = keys;
        data._custom = (this.state.value && this.state.value._custom) || {};

        this.setState({
            multiSelectValue: keys,
            value: data
        });

        this.processOnChange(data, false);
    };

    processOnChange(value, valid: boolean) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, valid);
        }

        if (this.props.options != null && typeof this.props.options.onThemeChange === 'function') {
            this.props.options.onThemeChange(value, valid);
        }
    }

    handleThemeCustomChange = (value, valid: boolean) => {
        let res = this.state.value || {};

        res = _.clone(res);
        res._custom = value;

        this.setState({ value: res });

        this.processOnChange(res, !valid);
    };

    // themesSearch = (values, search, valuesHash, displayKey, type) => {
    //     var arr = [];

    //     _.each(values, function (value) {
    //         var res;

    //         if (typeof value !== 'string') {
    //             return;
    //         }
    //         if (valuesHash[value] == null) {
    //             return;
    //         }
    //         if (_.indexOf(valuesHash[value].type, type) === -1) {
    //             return;
    //         }

    //         var displayString = valuesHash[value][displayKey];

    //         var searchValue = displayString.toLowerCase();
    //         var i;

    //         if ((i = searchValue.indexOf(search)) !== -1) {
    //             res = [
    //                 displayString.slice(0, i),
    //                 displayString.slice(i, i + search.length),
    //                 displayString.slice(i + search.length)
    //             ];
    //         }

    //         if (res != null) {
    //             arr.push({
    //                 value: value,
    //                 display: displayString,
    //                 match: res
    //             });
    //         }
    //     });

    //     arr.sort(function (a, b) {
    //         if (a.display === b.display) {
    //             return 0;
    //         }
    //         if (a.display > b.display) {
    //             return 1;
    //         }
    //         if (a.display < b.display) {
    //             return -1;
    //         }
    //     });

    //     return arr;
    // };

    getThemeElement(obj) {
        const EditComponent = (this.state.themeField.constructor as any).EditComponent;

        let parentThemes = [this.state.value];

        parentThemes = parentThemes.concat(this.props.parentThemes);

        if (this.props.parentThemes != null) {
            //LL: 13.03.20
            parentThemes = parentThemes.concat(this.props.parentThemes);
        }

        //LL: 27.08.20: savedState used for ThemeField to save internal state (selected section and collapsed) through component rebuild
        //    try "controlled" component: save selected and collapsed externaly
        //         was options={ this.props.options }
        let options: any = this.props.options;

        if (options == null) {
            options = {};
        }

        options.savedState = this.state.savedState;

        return (
            <ParameterField key={obj} param={this.state.themeField}>
                <EditComponent
                    value={obj}
                    parentThemes={parentThemes}
                    levels={this.state.levels}
                    options={options}
                    widgetValues={this.state.widgetValues}
                    widgetTypeName={this.state.widgetTypeName}
                    onChange={this.handleThemeCustomChange}
                    glob={this.props.glob}
                />
            </ParameterField>
        );
    }

    toogleInfoTooltip = () => {
        this.setState({
            infoTooltipVisible: !this.state.infoTooltipVisible
        });
    };

    showInfoTooltip = () => {
        this.setState({
            infoTooltipVisible: true
        });
    };

    hideInfoTooltip = () => {
        this.setState({
            infoTooltipVisible: false
        });
    };

    // rejectMultiSelectValue() {
    //     var themesIds = _.keys(this.state.themesHash);
    //     var multiSelectValue = this.state.multiSelectValue;
    //     return _.reject(multiSelectValue, function (Id) {
    //         return !_.contains(themesIds, Id.toString());
    //     });
    // }

    checkAllThemesExist = () => {
        var themesIds = _.keys(this.state.themesHash);
        var multiSelectValue = this.state.multiSelectValue;

        return _.filter(multiSelectValue, function (Id) {
            return !_.contains(themesIds, Id.toString());
        });
    };

    render() {
        if (this.state.loadingThemes === true) {
            return <ProgressBar />;
        }

        const custom = this.getThemeElement((this.state.value && this.state.value._custom) || {});

        var parentThemes = appTheme.extend.apply(
            _,
            [{}, this.state.value, this.props.options && this.props.options.parentTheme].concat(this.props.parentThemes)
        );

        delete parentThemes[THEME_ID_LIST_FIELD_NAME];
        delete parentThemes._custom;

        var customCount = _.keys(this.state.value._custom).length;
        var inheritedCount = _.keys(parentThemes).length;

        var customTitle = [];

        var style: React.CSSProperties = {
            pointerEvents: 'none'
        };

        if (customCount !== 0) {
            customTitle = customTitle.concat([
                <div key="custom-count" className="btn btn-outline-secondary shadow-none" style={style}>
                    <span key={'custom-count-icon'} className="glyphicon glyphicon-pencil"></span>
                    <span key="custom-count" className="vars-value">
                        {'Options set here: ' + customCount}
                    </span>
                </div>
            ]);
        }

        if (inheritedCount !== 0) {
            customTitle = customTitle.concat([
                <div key="inherited-count" className="btn btn-outline-secondary shadow-none" style={style}>
                    <span key="inherited-count-icon" className="glyphicon glyphicon-arrow-down"></span>
                    <span key="inherited-count" className="vars-value">
                        {'Inherited options: ' + inheritedCount}
                    </span>
                </div>
            ]);
        }

        var customContent;

        if (this.props.options && this.props.options.hideCustom) {
            customContent = null;
        } else {
            customContent = [<div key={'customize-button'}>{customTitle}</div>, custom];
        }

        var multiSelectValue = this.state.multiSelectValue; //this.rejectMultiSelectValue();
        var unexistingThemes = this.checkAllThemesExist();
        let errors;

        if (unexistingThemes != null && unexistingThemes.length > 0) {
            if (unexistingThemes.length === 1) {
                errors = (
                    <div className="text-danger">
                        {'Theme with ID ' +
                            unexistingThemes.join(', ') +
                            ' is no longer exist in the Database. Please, delete it from the list above.'}
                    </div>
                );
            } else {
                errors = (
                    <div className="text-danger">
                        {'Themes with IDs ' +
                            unexistingThemes.join(', ') +
                            ' are no longer exist in the Database. Please, delete them from the list above.'}
                    </div>
                );
            }
        }

        return (
            <div className="themes-list-select">
                <ThemesTableSelect
                    values={_.keys(this.state.themesHash)}
                    valuesHash={this.state.themesHash}
                    displayKey={'name'}
                    value={multiSelectValue}
                    //search={this.themesSearch}
                    types={this.state.themeTypes}
                    singleSelectMode={false}
                    theme={parentThemes}
                    glob={this.props.glob}
                    onChange={this.handleChange}
                />
                {errors}
                {customContent}
            </div>
        );
    }
}
